import React, { ReactElement } from 'react';

const WarningIcon = (props: any): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" viewBox="0 0 36 32" fill="none" {...props}>
      <path
        d="M0 31.5171L17.9673 0.482666L35.9347 31.5171H0ZM17.9673 26.617C18.4301 26.617 18.8181 26.4604 19.1311 26.1474C19.4442 25.8343 19.6007 25.4464 19.6007 24.9836C19.6007 24.5208 19.4442 24.1328 19.1311 23.8198C18.8181 23.5067 18.4301 23.3502 17.9673 23.3502C17.5045 23.3502 17.1166 23.5067 16.8035 23.8198C16.4905 24.1328 16.3339 24.5208 16.3339 24.9836C16.3339 25.4464 16.4905 25.8343 16.8035 26.1474C17.1166 26.4604 17.5045 26.617 17.9673 26.617ZM16.3339 21.7168H19.6007V13.5498H16.3339V21.7168Z"
        fill="#DD0B24"
      />
    </svg>
  );
};

export default WarningIcon;
